import { ROUTER_PATH } from "./path";

export const JWT_KEY = "accessToken";
export const DEFAULT_COMPANY_NAME = "OCTO";
export const COMPANY_FULL_NAME = "주식회사 어반웰스";
export const MOBILE_PHONE_PREFIX_LIST = [
  "010",
  "011",
  "016",
  "017",
  "018",
  "019",
];

export const DATE_FORMAT = "YYYY-MM-DD";
export const DATE_TIME_FORMAT = "YYYY-MM-DD HH:mm";
export const NOTIFICATION_DATE_FORMAT = "MM. DD";

export const DOCUMENT_CATEGORY_UUID = {
  WORK: "7e0a113b-ac8d-11ef-a518-02b012ed9399",
  ANALYSIS: "7e0b03c2-ac8d-11ef-a518-02b012ed9399",
  ARCHIVES: "7e0b1bcd-ac8d-11ef-a518-02b012ed9399",
};

export const DOCUMENT_UUID = {
  WORK: {
    uuid: "7e0a113b-ac8d-11ef-a518-02b012ed9399",
    classes: {
      휴가신청서: {
        uuid: "94640c0b-b215-11ef-a518-02b012ed9399",
      },
      "공문 수신": {
        uuid: "946415fb-b215-11ef-a518-02b012ed9399",
      },
      "공문 발신": {
        uuid: "94641f6a-b215-11ef-a518-02b012ed9399",
      },
      지출결의서: {
        uuid: "94642017-b215-11ef-a518-02b012ed9399",
      },
      품의서: {
        uuid: "9464207b-b215-11ef-a518-02b012ed9399",
      },
      보고서: {
        uuid: "946420d9-b215-11ef-a518-02b012ed9399",
      },
      회의록: {
        uuid: "9464213a-b215-11ef-a518-02b012ed9399",
      },
      KSS: {
        uuid: "94642192-b215-11ef-a518-02b012ed9399",
      },
      "법인카드 사용 증빙": {
        uuid: "94642250-b215-11ef-a518-02b012ed9399",
      },
    },
  },
  ANALYSIS: {
    uuid: "7e0b03c2-ac8d-11ef-a518-02b012ed9399",
    classes: {
      수주정보: {
        uuid: "946421f1-b215-11ef-a518-02b012ed9399",
        name: "수주정보",
      },
    },
  },
  ARCHIVES: {
    uuid: "7e0b1bcd-ac8d-11ef-a518-02b012ed9399",
    classes: {
      정책: { uuid: "df37804f-b522-11ef-ba28-0242ac120002" },
      기사: { uuid: "e4c89a30-b522-11ef-ba28-0242ac120002" },
      보고서: { uuid: "def112fd-db22-4de8-aeec-9eabab015f54" },
    },
  },
};

export const DOCUMENT_CLASS_UUID = {
  "94640c0b-b215-11ef-a518-02b012ed9399": "휴가신청서",
  "946415fb-b215-11ef-a518-02b012ed9399": "공문 수신",
  "94641f6a-b215-11ef-a518-02b012ed9399": "공문 발신",
  "9464207b-b215-11ef-a518-02b012ed9399": "품의서",
  "94642017-b215-11ef-a518-02b012ed9399": "지출결의서",
  "9464213a-b215-11ef-a518-02b012ed9399": "회의록",
  "946420d9-b215-11ef-a518-02b012ed9399": "보고서",
  "94642192-b215-11ef-a518-02b012ed9399": "KSS",
  "94642250-b215-11ef-a518-02b012ed9399": "법인카드 사용 증빙",
} as const;

export const BLANK_PLACEHOLDER = "-";

export const KOREA_REGION = {
  서울특별시: [
    "종로구",
    "중구",
    "용산구",
    "성동구",
    "광진구",
    "동대문구",
    "중랑구",
    "성북구",
    "강북구",
    "도봉구",
    "노원구",
    "은평구",
    "서대문구",
    "마포구",
    "양천구",
    "강서구",
    "구로구",
    "금천구",
    "영등포구",
    "동작구",
    "관악구",
    "서초구",
    "강남구",
    "송파구",
    "강동구",
  ],
  부산광역시: [
    "중구",
    "서구",
    "동구",
    "영도구",
    "부산진구",
    "동래구",
    "남구",
    "북구",
    "해운대구",
    "사하구",
    "금정구",
    "강서구",
    "연제구",
    "수영구",
    "사상구",
    "기장군",
  ],
  대구광역시: [
    "중구",
    "동구",
    "서구",
    "남구",
    "북구",
    "수성구",
    "달서구",
    "달성군",
  ],
  인천광역시: [
    "중구",
    "동구",
    "미추홀구",
    "연수구",
    "남동구",
    "부평구",
    "계양구",
    "서구",
    "강화군",
    "옹진군",
  ],
  광주광역시: ["동구", "서구", "남구", "북구", "광산구"],
  대전광역시: ["동구", "중구", "서구", "유성구", "대덕구"],
  울산광역시: ["중구", "남구", "동구", "북구", "울주군"],
  세종특별자치시: ["세종시"],
  경기도: [
    "수원시",
    "고양시",
    "용인시",
    "성남시",
    "부천시",
    "안산시",
    "남양주시",
    "화성시",
    "평택시",
    "의정부시",
    "시흥시",
    "파주시",
    "김포시",
    "광주시",
    "광명시",
    "안양시",
    "군포시",
    "의왕시",
    "하남시",
    "양주시",
    "구리시",
    "오산시",
    "안성시",
    "포천시",
    "동두천시",
    "여주시",
    "이천시",
    "양평군",
    "가평군",
    "연천군",
  ],
  강원도: [
    "춘천시",
    "원주시",
    "강릉시",
    "동해시",
    "태백시",
    "속초시",
    "삼척시",
    "홍천군",
    "횡성군",
    "영월군",
    "평창군",
    "정선군",
    "철원군",
    "화천군",
    "양구군",
    "인제군",
    "고성군",
    "양양군",
  ],
  충청북도: [
    "청주시",
    "충주시",
    "제천시",
    "보은군",
    "옥천군",
    "영동군",
    "증평군",
    "진천군",
    "괴산군",
    "음성군",
    "단양군",
  ],
  충청남도: [
    "천안시",
    "공주시",
    "보령시",
    "아산시",
    "서산시",
    "논산시",
    "계룡시",
    "당진시",
    "금산군",
    "부여군",
    "서천군",
    "청양군",
    "홍성군",
    "예산군",
    "태안군",
  ],
  전라북도: [
    "전주시",
    "군산시",
    "익산시",
    "정읍시",
    "남원시",
    "김제시",
    "완주군",
    "진안군",
    "무주군",
    "장수군",
    "임실군",
    "순창군",
    "고창군",
    "부안군",
  ],
  전라남도: [
    "목포시",
    "여수시",
    "순천시",
    "나주시",
    "광양시",
    "담양군",
    "곡성군",
    "구례군",
    "고흥군",
    "보성군",
    "화순군",
    "장흥군",
    "강진군",
    "해남군",
    "영암군",
    "무안군",
    "함평군",
    "영광군",
    "장성군",
    "완도군",
    "진도군",
    "신안군",
  ],
  경상북도: [
    "포항시",
    "경주시",
    "김천시",
    "안동시",
    "구미시",
    "영주시",
    "영천시",
    "상주시",
    "문경시",
    "경산시",
    "군위군",
    "의성군",
    "청송군",
    "영양군",
    "영덕군",
    "청도군",
    "고령군",
    "성주군",
    "칠곡군",
    "예천군",
    "봉화군",
    "울진군",
    "울릉군",
  ],
  경상남도: [
    "창원시",
    "김해시",
    "진주시",
    "양산시",
    "거제시",
    "통영시",
    "사천시",
    "밀양시",
    "함안군",
    "창녕군",
    "고성군",
    "남해군",
    "하동군",
    "산청군",
    "함양군",
    "거창군",
    "합천군",
  ],
  제주특별자치도: ["제주시", "서귀포시"],
} as const;

export const METER_TO_PYEONG = 0.3025;

export const ADMIN_TYPES = ["SUPERADMIN", "ADMIN"];

export const ATTACHMENT_FILE_SIZE_LIMIT_IN_MB = 100;
export const ATTACHMENT_FILE_SIZE_LIMIT =
  ATTACHMENT_FILE_SIZE_LIMIT_IN_MB * 1000 * 1000;

export const DOCUMENT_ALLOWED_EXTENSIONS = ["*"];

export const MAX_ATTACHMENTS = 10;

export const MAX_REFERENCE_USERS = 5;

export const AUTHORITY_TYPES = {
  대표이사: "대표이사",
  정회원A: "정회원A",
  정회원B: "정회원B",
  정회원C: "정회원C",
} as const;

export const LOCAL_TIME_FORMAT = "YYYY-MM-DDTHH:mm:ss";

export const PUSH_NOTIFICATION_TYPE = {
  NOTICE_REGISTRATION: "NOTICE_REGISTRATION",
  REQUEST_REVIEW: "REQUEST_REVIEW",
  REQUEST_APPROVAL: "REQUEST_APPROVAL",
  REQUEST_NOT_ANALYSIS: "REQUEST_NOT_ANALYSIS",
  REQ_SUPPLEMENT: "REQ_SUPPLEMENT",
  REVIEW: "REVIEW",
  APPROVE: "APPROVE",
  APPROVE_NOT_ANALYSIS: "APPROVE_NOT_ANALYSIS",
  ARCHIVES_REGISTRATION: "ARCHIVES_REGISTRATION",
} as const;

export const NOTIFICATION_ROUTER_PATH = {
  // 공지 사항 등록 -> 공지사항 상세페이지
  NOTICE_REGISTRATION: ROUTER_PATH.notice.dashboard.detail,

  // ANALYSIS 문서 1단계 결재 요청
  REQUEST_REVIEW: ROUTER_PATH.document.analysis.detail,
  // ANALYSIS 문서 2단계 결재 요청
  REQUEST_APPROVAL: ROUTER_PATH.document.analysis.detail,
  // WORK 문서 결재 요청
  REQUEST_NOT_ANALYSIS: ROUTER_PATH.document.work.detail,

  // 보완 요청
  REQ_SUPPLEMENT: {
    WORK: `${ROUTER_PATH.myPage.desk}?selectedTab.name=WORK&selectedTab.uuid=${DOCUMENT_CATEGORY_UUID.WORK}&documentStatus=REQ_SUPPLEMENT&page=1`,
    ANALYSIS: `${ROUTER_PATH.myPage.desk}?selectedTab.name=ANALYSIS&selectedTab.uuid=${DOCUMENT_CATEGORY_UUID.ANALYSIS}&documentStatus=REQ_SUPPLEMENT&page=1`,
  },

  // ANALYSIS 문서 1단계 승인 완료
  REVIEW: ROUTER_PATH.document.analysis.detail,
  // ANALYSIS 문서 2단계 승인 완료
  APPROVE: ROUTER_PATH.document.analysis.detail,
  // WORK 문서 승인 완료
  APPROVE_NOT_ANALYSIS: ROUTER_PATH.document.work.detail,

  // Archieve 문서 등록
  ARCHIVES_REGISTRATION: ROUTER_PATH.document.archive.dashboard,
} as const;
